import * as React from 'react';
import { TryInStoreBanner as TryInStoreBanner$1 } from '@grandvisionhq/fun-try-in-store';
import { compose } from '@grandvisionhq/utils';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsTryInStoreBanner = ({})=>{
    return /*#__PURE__*/ React.createElement(TryInStoreBanner$1, null);
};
var TryInStoreBanner = compose(withHidableContent)(CmsTryInStoreBanner);

export { CmsTryInStoreBanner, TryInStoreBanner as default };
//# sourceMappingURL=TryInStoreBanner.js.map
